import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CompaniesListComponent } from './companies-list/companies-list.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: CompaniesListComponent,
        data: {
          title: 'Companies'
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CompaniesRoutingModule {
}
